import axios, { AxiosInstance, AxiosResponse } from "axios";
import { GenerateSpareForecastResponse } from "../../@types/DRO/GenerateSpareForecastResponse";
import { GenerateSpareForecastBody } from "../../@types/DTO/GenerateSpareForecastBody";

export class SpareForecastApi {
  public static api = new SpareForecastApi();
  private instance: AxiosInstance;

  constructor() {
    this.instance = axios.create({
      baseURL: process.env.REACT_APP_AI_ML_BASE_URL || "https://ai.bcykal.com/ai-ml-stag/api",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  }

  getToken() {
    return localStorage.getItem("token");
  }

  async generateSpareForecast(
    requestBody: GenerateSpareForecastBody
  ): Promise<GenerateSpareForecastResponse> {
    try {
      const response: AxiosResponse<GenerateSpareForecastResponse> =
        await this.instance.post(
          `/generate-spare-forecast`,
          requestBody,
          {
            headers: {
              Authorization: `Bearer ${this.getToken()}`,
            },
          }
        );
      return response.data;
    } catch (error) {
      console.error("Error generating spare forecast", error);
      throw error;
    }
  }

  async getSparesCities(): Promise<string[]> {
    try {
      const response: AxiosResponse<{ data: string[] }> = await this.instance.get(
        `/spares/dropdown-cities`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      return response.data.data || [];
    } catch (error) {
      console.error("Error fetching spares cities", error);
      throw error;
    }
  }

  async getPartCategories(): Promise<string[]> {
    try {
      const response: AxiosResponse<{ data: string[] }> = await this.instance.get(
        `/spares/dropdown-part-categories`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      return response.data.data || [];
    } catch (error) {
      console.error("Error fetching part categories", error);
      throw error;
    }
  }

  async getSparesOem(): Promise<string[]> {
    try {
      const response: AxiosResponse<{ data: string[] }> = await this.instance.get(
        `/spares/dropdown-oem`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      return response.data.data || [];
    } catch (error) {
      console.error("Error fetching spares OEM", error);
      throw error;
    }
  }

  async getStockoutParts(): Promise<number[]> {
    try {
      const response: AxiosResponse<{ data: number[] }> = await this.instance.get(
        `/spares/dropdown-stockout`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      return response.data.data || [];
    } catch (error) {
      console.error("Error fetching stockout parts", error);
      throw error;
    }
  }
}
